import { sendGoogleEvent } from '@html/_common/utils';
import MainSearch from '@html/_common/search/script';

const SEARCH_WRAPPER_CLASS_JS = '.js-ao-clp-clean-search__search';
const MONTH_WRAPPER_CLASS_JS = '.js-ao-clp-clean-search__when';
const TYPE_WRAPPER_CLASS_JS = '.js-ao-clp-clean-search__who';
const CTA_CLASS_JS = '.js-ao-clp-clean-search__cta-input';
const MOBILE_FLOW_CLASS = 'ao-clp-clean-search__container--mobile-flow';
const MOBILE_HEADER_CLASS = 'js-ao-clp-clean-search__mobile-header';
const MOBILE_CTA_CLASS = 'js-ao-clp-clean-search__mobile-cta';
const ADVENTURE_TYPE_SWITCH_CONTAINER_CLASS = '.js-ao-clp-clean-search__switch';
const ADVENTURE_TYPE_SWITCH_CLASS = 'input[name="adventureTypeRadio"]';
const ADVENTURE_TYPE_CHECKBOX_CONTAINER_CLASS = '.am-type-selector__wrapper';
const ADVENTURE_TYPE_INFO_CLASS = '.js-ao-clp-clean-search__switch-info';
const ADVENTURE_TYPE_INFO_MODAL_CLASS = '.js-ao-clp-clean-search__info-modal';
const ADVENTURE_TYPE_INFO_MODAL_CLOSE_CLASS = '.js-ao-clp-clean-search__info-modal--close-btn';
const CTA_CLASS_NAME_MOBILE_JS = 'ao-clp-clean-search__mobile-cta--full';
const SEARCH_ITEM_CLASS = 'js-ao-clp-clean-search__item';
const CONTAINER_CLASS = 'js-ao-clp-clean-search__container';
const MOBILE_BACK_CLASS = 'js-ao-clp-clean-search__mobile-top-back';
const MOBILE_FOOTER_CLASS = 'js-ao-clp-clean-search__mobile-footer';
const MOBILE_MAIN_CLASS = 'js-ao-clp-clean-search__';
const MOBILE_SUB_HEADER = 'js-ao-clp-clean-search__mobile-sub-header';
const CLEAN_BUTTON = 'js-ao-clp-clean-search__where--delete';
const TOUR_TYPE_ID_PERSONALIZED = '402';

export default function AOClpCleanSearch() {
  let $searchWrapper = null;
  let $monthWrapper = null;
  let $typeWrapper = null;
  let $ctaButton = null;
  let $adventureTypeSwitch = null;
  let $adventureTypeInfo = null;
  let $adventureTypeModal = null;
  let $adventureTypeModalClose = null;
  let mainSearch = null;
  let searchIndexes = null;
  let customDomain = '';
  let isShop = false;

  const switchToWhere = () => {
    const $cta = $(`.${MOBILE_CTA_CLASS}`);
    $(`.${MOBILE_FLOW_CLASS} .${MOBILE_HEADER_CLASS}`).addClass('hid');
    $(`.${MOBILE_FLOW_CLASS} .${MOBILE_HEADER_CLASS}--where`).removeClass('hid');

    $(`.${MOBILE_FLOW_CLASS} .${SEARCH_ITEM_CLASS}`).removeClass('hid').removeClass('show');

    $(`.${MOBILE_BACK_CLASS}`).addClass('hid');
    $(`.${MOBILE_FOOTER_CLASS}`).addClass('hid');

    $(`.${CONTAINER_CLASS}`).removeClass(MOBILE_FLOW_CLASS);
    $(ADVENTURE_TYPE_SWITCH_CONTAINER_CLASS).hide();

    $cta.removeClass(CTA_CLASS_NAME_MOBILE_JS).text($cta.data('placeholder-init'));

    $('body').removeClass('lock');
    $('html, body').removeClass('search-focused');
    $(window).scrollTop(0);
  };

  const displayAvailableAdventureTypes = (switchValue, $container) => {
    $container.find('input[type="checkbox"]').forEach((el) => {
      if (switchValue === 'standard' && $(el).prop('id') === TOUR_TYPE_ID_PERSONALIZED) {
        $(el).parent('label').addClass('hid');
        $(el).prop('disabled', false).prop('checked', false);
        $(el).trigger('change');
        return;
      }

      if (switchValue === 'standard') {
        $(el).parent('label').removeClass('hid');
      }

      if (switchValue === 'personalized' && $(el).prop('id') === TOUR_TYPE_ID_PERSONALIZED) {
        $(el).parent('label').removeClass('hid');
        $(el).prop('checked', true).prop('disabled', true);
        $(el).trigger('change');
        return;
      }

      if (switchValue === 'personalized') {
        $(el).parent('label').addClass('hid');
        $(el).prop('checked', false);
      }
    });
  };

  const initiateMainSearch = () => {
    searchIndexes = $searchWrapper.data('indexes');
    mainSearch = new MainSearch();
    mainSearch.initiate({
      $searchInput: $searchWrapper,
      searchIndexes,
      $monthBlock: $monthWrapper,
      $ctaButton,
      $typeBlock: $typeWrapper,
      blockName: 'clp-clean-search',
      customDomain,
      isShop,
      mobileParameters: {
        width: 767,
        container: CONTAINER_CLASS,
        flowClass: MOBILE_FLOW_CLASS,
        headerClass: MOBILE_HEADER_CLASS,
        subHeaderClass: MOBILE_SUB_HEADER,
        back: MOBILE_BACK_CLASS,
        footer: MOBILE_FOOTER_CLASS,
        searchItem: SEARCH_ITEM_CLASS,
        mainClassName: MOBILE_MAIN_CLASS,
        cta: MOBILE_CTA_CLASS,
        ctaClass: CTA_CLASS_NAME_MOBILE_JS,
        cleanButton: CLEAN_BUTTON,
        switchContainer: ADVENTURE_TYPE_SWITCH_CONTAINER_CLASS,
      },
    });

    $('body').on('click', `.${MOBILE_CTA_CLASS}`, () => {
      const $cta = $(`.${MOBILE_CTA_CLASS}`);

      if (!$cta.hasClass(CTA_CLASS_NAME_MOBILE_JS)) {
        mainSearch.deSelectMonths();
        mainSearch.switchMobileToNext('who');
        return;
      }

      mainSearch.searchAction();
    });

    $adventureTypeSwitch.on('click', (event) => {
      const switchValue = event.currentTarget.value;
      sendGoogleEvent(
        'Main Search',
        'Home Toggle Clicked',
        switchValue,
        {
          ampEventName: 'home_toggle_clicked',
          adventureTypeSwitchValue: switchValue,
        },
      );

      if ($(ADVENTURE_TYPE_CHECKBOX_CONTAINER_CLASS).length > 0) {
        const $container = $(ADVENTURE_TYPE_CHECKBOX_CONTAINER_CLASS);
        displayAvailableAdventureTypes(switchValue, $container);
        return;
      }
      mainSearch.initiateTypes();
    });

    $adventureTypeInfo.on('click', () => {
      $adventureTypeModal.removeClass('hid');
      const selectedAdventureType = $adventureTypeSwitch.find('input:checked').val();
      sendGoogleEvent(
        'Main Search',
        'Home Toggle Info Clicked',
        selectedAdventureType,
        {
          ampEventName: 'home_toggle_info_clicked',
          adventureTypeSwitchValue: selectedAdventureType,
        },
      );
    });

    $adventureTypeModalClose.on('click', () => {
      $adventureTypeModal.addClass('hid');
    });

    $('.js-ao-clp-clean-search__mobile-top-close').click(switchToWhere);

    $(`.${MOBILE_BACK_CLASS}`).click(() => {
      const isWhenStepDone = $(`.${MOBILE_HEADER_CLASS}--where`).hasClass('hid') && $(`.${MOBILE_HEADER_CLASS}--when`).hasClass('hid');
      const switchToBlock = isWhenStepDone ? 'when' : 'where';
      const $cta = $(`.${MOBILE_CTA_CLASS}`);

      $(`.${MOBILE_FLOW_CLASS} .${MOBILE_HEADER_CLASS}`).addClass('hid');
      $(`.${MOBILE_FLOW_CLASS} .${MOBILE_HEADER_CLASS}--${switchToBlock}`).removeClass('hid');

      $(`.${MOBILE_FLOW_CLASS} .${SEARCH_ITEM_CLASS}`).addClass('hid').removeClass('show');
      $(`.${MOBILE_FLOW_CLASS} .${MOBILE_MAIN_CLASS}${switchToBlock}`).removeClass('hid').addClass('show');

      $(`.${MOBILE_FOOTER_CLASS}`).addClass('hid');

      if (switchToBlock === 'where') {
        $(`.${MOBILE_BACK_CLASS}`).addClass('hid');
        mainSearch.showWhere();
      }

      if (switchToBlock === 'when') {
        $(`.${MOBILE_FOOTER_CLASS}`).removeClass('hid');
        $cta.removeClass(CTA_CLASS_NAME_MOBILE_JS).text($cta.data('placeholder-init'));

        setTimeout(() => {
          mainSearch.showMonths();
        }, 30);
      }
    });
  };

  const initiate = () => {
    $searchWrapper = $(SEARCH_WRAPPER_CLASS_JS);
    $monthWrapper = $(MONTH_WRAPPER_CLASS_JS);
    $typeWrapper = $(TYPE_WRAPPER_CLASS_JS);
    $ctaButton = $(CTA_CLASS_JS);
    $adventureTypeSwitch = $(ADVENTURE_TYPE_SWITCH_CLASS);
    $adventureTypeInfo = $(ADVENTURE_TYPE_INFO_CLASS);
    $adventureTypeModal = $(ADVENTURE_TYPE_INFO_MODAL_CLASS);
    $adventureTypeModalClose = $(ADVENTURE_TYPE_INFO_MODAL_CLOSE_CLASS);

    if (window.location.pathname === '/agents') customDomain = window.trConfig.travelagentsUrl;

    isShop = !!window.trConfig.customization?.is_shop;

    if ($searchWrapper.length === 0) return;

    initiateMainSearch();
  };

  return { initiate };
}
